import {
  Group, Mesh, SphereGeometry, MeshBasicMaterial, TubeGeometry,
  CatmullRomCurve3, ShaderMaterial, Vector3, AdditiveBlending,
} from "three";
import vert from "../shaders/flux_tube.vert?raw";
import frag from "../shaders/flux_tube.frag?raw";
import { detectFromBrowser, settingsForTier } from "../engine/tier";
import type { Chapter } from "./index";

export function createCh2Gluon(): Chapter {
  const group = new Group();
  const settings = settingsForTier(detectFromBrowser());

  const colors = [0xff5566, 0x55ff77, 0x5577ff];
  const positions = [
    new Vector3(-0.7, 0.5, 0),
    new Vector3(0.8, 0.3, 0.2),
    new Vector3(0, -0.6, -0.3),
  ];

  const quarks = positions.map((p, i) => {
    const m = new Mesh(
      new SphereGeometry(0.18, 16, 16),
      new MeshBasicMaterial({ color: colors[i] }),
    );
    m.position.copy(p);
    group.add(m);
    return m;
  });

  const tubes: { mesh: Mesh; mat: ShaderMaterial }[] = [];
  for (let i = 0; i < 3; i++) {
    const a = positions[i], b = positions[(i + 1) % 3];
    const mid = a.clone().add(b).multiplyScalar(0.5);
    mid.y += 0.1;
    const curve = new CatmullRomCurve3([a, mid, b]);
    const geom = new TubeGeometry(curve, settings.fluxTubeSamples, 0.04, 6, false);
    const mat = new ShaderMaterial({
      vertexShader: vert,
      fragmentShader: frag,
      uniforms: {
        uTime: { value: 0 },
        uColorA: { value: new Vector3(1.0, 0.5, 0.2) },
        uColorB: { value: new Vector3(0.2, 0.6, 1.0) },
      },
      transparent: true,
      blending: AdditiveBlending,
    });
    const mesh = new Mesh(geom, mat);
    group.add(mesh);
    tubes.push({ mesh, mat });
  }

  group.visible = false;

  return {
    id: 2,
    enter(ctx) { ctx.scene.add(group); group.visible = true; },
    exit(_ctx) { group.visible = false; },
    update(_ctx, t, _dt, local) {
      for (const tube of tubes) tube.mat.uniforms.uTime.value = t;
      group.rotation.y = local * Math.PI * 0.6;
      for (let i = 0; i < quarks.length; i++) {
        const wobble = Math.sin(t * 1.5 + i) * 0.05;
        quarks[i].position.y = positions[i].y + wobble;
      }
    },
  };
}
